import join from '../images/join.jpg'
import '../components/css components/logistics.css';
import rdcover from "../images/cover-all.jpg";
import circle from "../images/R&D-modified.png";
function Rd(){
    return(
        <div className='logistics' id='rd'> 
                    <div className='stick-them'>
                        <img src={rdcover} alt='logistics' className='cover-all'/>
                        <img src={circle} alt='logistics' className='circle-c' />
                    </div>
                    <h2>R&D Circle</h2>
                    <p className='quote'>"Knowledge Nerdz, Through tireless search, we uncover hidden gems of knowledge, while development transforms those gems into innovative solutions."</p>
                    <p className='paragraph'>The R&D circle within our team serves a dual purpose, addressing both internal and external aspects. Internally, it focuses on skill enhancement and professional development for team members, while externally, it extends its reach to students and technology enthusiasts, offering valuable insights into cutting-edge technologies. Here, we break down the key aspects and benefits of R&D circle:
                    <ul>
                        <li>Empowers individuals with the ability to conduct effective information searches across various platforms.</li>
                        <li>Nurtures proficiency in technical writing, utilizing a diverse set of tools including office software for documentation.</li>
                        <li>Provides opportunities for individuals to construct portfolios.</li>
                        <li>Offers expertise in the creation of digital content, a valuable skill in today's digital landscape.</li>
                        <li>Ideal for those with a passion for research and information gathering.</li>
                        <li>Encourages the development of creative writing skills and the ability to convey complex information in a simplified manner.</li>
                    </ul>
                    In summary, R&D circle provides opportunities for both personal growth and skill enhancement, catering to a wide range of interests and skill levels.
                    </p>
        </div>
    );
}

export default Rd;